import React from 'react'
import { Icon } from 'semantic-ui-react'
import { manufacturerToClass } from '@cbgms/components/src/utils/vehicle'
import { IconSizeProp } from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon'

export interface IVehicleDetailsProps {
  manufacturer?: string
  size?: IconSizeProp
}

export const VehicleMakeImage: React.FC<IVehicleDetailsProps> = ({ manufacturer, size }) => {
  return <Icon size={size || 'large'} className={`icon vehicle brand ${manufacturerToClass(manufacturer)} summary-header-brand-icon`} />
}

VehicleMakeImage.displayName = 'VehicleMakeImage'
export default VehicleMakeImage
